import { render, staticRenderFns } from "./AddNewJobTable.vue?vue&type=template&id=610d53a2&scoped=true"
import script from "./AddNewJobTable.vue?vue&type=script&lang=js"
export * from "./AddNewJobTable.vue?vue&type=script&lang=js"
import style0 from "./AddNewJobTable.vue?vue&type=style&index=0&id=610d53a2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610d53a2",
  null
  
)

export default component.exports